import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);

export default new Vuex.Store({
    state:{
        userInfo:{},
        menus:[],
        auth:[],
        isGlobalSpin:false,
        isPolling: true,
    },
    mutations:{
        setUserInfo(state, userInfo){
            state.userInfo = userInfo
        },
        reset(state){
            state.userInfo = {};
        },
        setMenus(state, menus){
            state.menus = menus
        },
        resetMenus(state){
            state.menus = [];
        },
        setAuth(state,auth){
            state.auth = auth
        },
        changeGlobalSpin (state, show) {
            state.isGlobalSpin = show;
        },
        changePollingSpin (state, show) {
            state.isPolling = show;
        },
    },
    getters:{

    },
    actions:{
        resetAction({ commit }){
            commit('reset')
        },
        resetMen({ commit }){
            commit('resetMenus')
        }
    },
    modules:{
        
    },
    plugins: [createPersistedState()]
})